import {
  PauseCircleOutlined,
  LoadingOutlined,
  CheckCircleTwoTone,
  CloseOutlined,
} from "@ant-design/icons";
import { Col, Input, Pagination, Row, Table } from "antd";
import React from "react";

type History = {
  committedSql: string;
  createdAt: string;
  id: number;
  state: string;
};

type Props = {
  height: number;
  dataSource: History[];
  current: number;
  pageSize: number;
  total: number;
  onRollback: (sql: string) => void;
  onPageChange: (page: number, pageSize?: number) => void;
  onSearch: (key: string) => void;
};

export default function HistoryView(props: Props) {
  const {
    height,
    dataSource,
    current,
    pageSize,
    total,
    onRollback,
    onPageChange,
    onSearch,
  } = props;

  return (
    <>
      <div>
        <Input.Search
          placeholder="查询历史"
          onSearch={onSearch}
          style={{ width: "200px", margin: "15px" }}
          onChange={(e) => onSearch(e.target.value)}
        />
        <Table
          size="small"
          style={{
            width: "100%",
            height: height,
            overflowX: "auto",
            overflowY: "auto",
          }}
          rowClassName="site-data-grid-row"
          dataSource={dataSource}
          pagination={false}
          onRow={(record) => {
            return {
              onDoubleClick: (_) => {
                onRollback(record.committedSql);
              },
            };
          }}
          rowKey={(record) => record.id}
        >
          <Table.Column
            title="结果"
            key="id"
            dataIndex="state"
            width={50}
            render={(state) => {
              switch (state) {
                case "WAITING":
                  return <PauseCircleOutlined />;
                case "PENDING":
                  return <LoadingOutlined style={{ color: "#108ee9" }} />;
                case "OK":
                  return <CheckCircleTwoTone twoToneColor="#52c41a" />;
                case "FAIL":
                  return <CloseOutlined style={{ color: "#f5222d" }} />;
                default:
                  break;
              }
            }}
          />
          <Table.Column
            title="时间"
            key="id"
            dataIndex="createdAt"
            width={180}
          />
          <Table.Column
            title="SQL"
            key="id"
            dataIndex="committedSql"
            width={800}
            ellipsis
            render={(sql) => <code style={{ color: "#d4596f" }}>{sql}</code>}
          />
        </Table>
      </div>
      <Row>
        <Col flex="auto"></Col>
        <Col>
          <Pagination
            size="small"
            current={current}
            pageSize={pageSize}
            total={total}
            onChange={(page, pageSize) => onPageChange(page, pageSize)}
          />
        </Col>
      </Row>
    </>
  );
}
